module.exports = __webpack_public_path__ + "img/products.c5e83c96.svg";